import React from 'react';
import PropTypes from 'prop-types';
import defaultValidators from '../lib/validation';

export default function(ExtendedComponent) {
	return class ValidationComponent extends ExtendedComponent {
		static propTypes = Object.assign({}, ExtendedComponent.propTypes, {
			errors: PropTypes.object.isRequired,
		});
		static defaultProps = Object.assign({}, ExtendedComponent.defaultProps, {
			errors: {},
		});
		validate(key, value, validators = defaultValidators) {
			const { validationActions } = this.props;
			// Defer validation to prevent over-eager validation errors
			return window.setTimeout(() => {
				validationActions.updateValidationErrors({ [key]: validators[key].validate(value) });
			}, 100);
		}
		isValid(key, value, validators = defaultValidators) {
			this.validate(key, value, validators);
			return !validators[key].validate(value).length > 0;
		}
		isEveryValid() {
			if (this.validatedFields.length === 0) {
				return true;
			}
			return this.validatedFields
				.map(field => !this.hasErrors(field))
				.every(isValid => isValid);
		}
		hasErrors(key) {
			const { errors } = this.props;
			return key ? errors && !!errors[key] && !!errors[key].length : errors && !!Object.keys(errors).length;
		}
		clearValidation(key) {
			const { validationActions } = this.props;
			validationActions.updateValidationErrors({ [key]: [] });
		}
    };
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/mixins/Validation.js